// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.node, convertFragment, fRef);
}

let FormStateFragment_localDraftAttachmentStatus_decode = PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.Utils.localDraftAttachmentStatus_decode;

let FormStateFragment_localDraftAttachmentStatus_fromString = PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.Utils.localDraftAttachmentStatus_fromString;

let FormStateFragment = {
  localDraftAttachmentStatus_decode: FormStateFragment_localDraftAttachmentStatus_decode,
  localDraftAttachmentStatus_fromString: FormStateFragment_localDraftAttachmentStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function use$1(formState) {
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsPhotosAndFiles_formState_graphql.node, convertFragment, formState);
  if (formState$1.filesStatus.length !== 0 || formState$1.imagesStatus.length !== 0) {
    return "Invalid";
  } else {
    return "Valid";
  }
}

exports.FormStateFragment = FormStateFragment;
exports.use = use$1;
/* RescriptRelay_Fragment Not a pure module */
